import { Box, Stack, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { InfoIcon, useMinimalsTheme } from '@tom-ui/ui'
import { formatDateTime } from '@tom-ui/utils'
import dayjs from 'dayjs'
import { VesselVisitTableDto } from '../../Stores/VesselVisitViewStore'

interface VesselVisitTableDetailPanelProps {
  row: { original: VesselVisitTableDto }
}

export const VesselVisitTableDetailPanel = ({ row }: VesselVisitTableDetailPanelProps) => {
  const theme = useMinimalsTheme()
  const { t } = useTranslate()

  const {
    cargoType,
    discharge,
    load,
    restow,
    dockingSide,
    startOfOperations,
    endOfOperations,
    notes,
  } = row.original

  const renderItem = (title: string, name: string, value?: string | number | null) => {
    if (value === undefined || value === null) return null
    return (
      <Stack minWidth={200} p={2}>
        <Typography variant='subtitle2'>{title}</Typography>
        <Typography variant='body2' data-cy={`vessel-visit-detail-${name}`}>
          {value}
        </Typography>
      </Stack>
    )
  }

  const renderDateWithLabel = (date?: string | null, title?: string) => {
    const d = date ? dayjs(date) : undefined

    return (
      <Stack direction='column' spacing={1} minWidth={200} p={2}>
        {<Typography variant='subtitle2'>{title}</Typography>}
        <Typography variant='body2'>{d ? formatDateTime(d) : '-'}</Typography>
      </Stack>
    )
  }

  return (
    <Box
      sx={{
        bgcolor: theme.palette.grey[100],
        borderTop: `1px solid ${theme.palette.divider}`,
        borderBottom: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Stack direction={'row'}>
        <Stack
          direction={'row'}
          p={3}
          sx={{
            left: 0,
            position: 'sticky',
            borderRight: `1px solid ${theme.palette.divider}`,
            bgcolor: theme.palette.grey[100],
          }}
        >
          <InfoIcon sx={{ mr: 1 }} />
          <Typography variant='subtitle2' fontWeight={600}>
            {t('additionalInformation', 'Additional information')}
          </Typography>
        </Stack>

        <Stack direction={'column'}>
          <Stack direction='row' flexWrap='wrap'>
            {renderItem(t('cargoType', 'Cargo type'), 'cargo-type', cargoType)}
            {renderItem(t('discharge', 'Discharge'), 'discharge', discharge)}
            {renderItem(t('load', 'Load'), 'load', load)}
            {renderItem(t('restow', 'Restow'), 'restow', restow)}

            {renderDateWithLabel(startOfOperations, t('ato', 'ATO'))}
            {renderDateWithLabel(endOfOperations, t('atc', 'ATC'))}

            {renderItem(t('dockingSide', 'Docking side'), 'docking-side', dockingSide)}
          </Stack>

          {notes && (
            <Stack direction={'row'}>{renderItem(t('notes', 'Notes'), 'notes', notes)}</Stack>
          )}
        </Stack>
      </Stack>
    </Box>
  )
}
